import React, { useState } from 'react';
import AspireForm from './AspireForm';
import AspireTable from './AspireTable';
import { Alert } from 'antd';

const Aspire = ({ selectedBrand, filters }) => {
  const [refreshTable, setRefreshTable] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  const handleFormSuccess = () => {
    // Trigger table refresh when a new record is added
    setRefreshTable(!refreshTable);
  };

  const handleEditRecord = (record) => {
    setEditRecord(record);
    // Scroll to form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="container-fluid">
      {!selectedBrand && (
        <Alert
          message="Please select a brand"
          description="You need to select a brand to view and add letter processing records."
          type="warning"
          showIcon
          className="mb-4"
        />
      )}

      <h2 className="mb-4">Letter Processing</h2>
      
      <AspireForm 
        selectedBrand={selectedBrand} 
        onSuccess={handleFormSuccess} 
        editRecord={editRecord}
        setEditRecord={setEditRecord}
      />
      
      <AspireTable 
        selectedBrand={selectedBrand} 
        filters={filters}
        onEdit={handleEditRecord}
        onRefresh={handleFormSuccess}
        
        refreshTrigger={refreshTable}
      />
    </div>
  );
};

export default Aspire;
